export default __webpack_public_path__ + "static/media/mnt.472b89fc.svg";